var map = {
	"./adminC.webp": 7386,
	"./bioSC.webp": 8942,
	"./byfSh.jpeg": 7411,
	"./cPubliSh.jpeg": 1283,
	"./cPubliT.webp": 1311,
	"./conPubY.jpg": 1278,
	"./derC.webp": 806,
	"./derSh.jpeg": 6001,
	"./derechoSC.webp": 7822,
	"./derechoY.jpg": 1285,
	"./enfC.webp": 3518,
	"./enfeSC.webp": 5482,
	"./enfeT.webp": 3396,
	"./fisC.webp": 3849,
	"./fisioSC.webp": 8602,
	"./fisioT.webp": 9956,
	"./iComSh.jpeg": 2512,
	"./ingComY.jpg": 2296,
	"./medC.webp": 969,
	"./medicinaSC.webp": 6812,
	"./medicinaSh.jpeg": 9120,
	"./medicinaT.webp": 9266,
	"./odontoSC.webp": 7051,
	"./odontoT.webp": 2299,
	"./sistemasSC.webp": 929
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2712;